import { instance } from '../instance'

/**
 * Reset password by token
 *
 * @param token
 * @param password
 * @param password_repeat
 * @param region
 * @returns {Promise<AxiosResponse<any>>}
 */
export const resetPasswordToken = (
  token,
  { password, password_repeat },
  region,
) => {
  return instance.put(
    `/v1/auth/password/reset/${token}`,
    {
      password: password,
      password_repeat: password_repeat,
    },
    { params: { r: region } },
  )
}
